import React, {forwardRef, useEffect, useImperativeHandle, useRef, useState} from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./form8.css";
import {HeaderDashboard, SideNav} from "../Componat/Header and Side Nav/NavComponant";
import Form8Data from "./Form8Data";
import {BaseURL} from "../../../API/API";
import {
    AddExtraField,
    ColumnNumber,
    Form8LastInfo, LableColumn, Row1, Row2, Row3, Row4,
    Section1,
    Section2,
    Section3,
    Section4,
    Section5,
    SiteBoundaries, Thead, Tip
} from "../Componat/InputComponant";
import {useNavigate} from "react-router-dom";
export default function () {
    const [isOpen, setIsOpen] = useState(true);
    const toggleSidebar = () => setIsOpen(!isOpen);

    return (
        <div className="d-flex flex-column min-vh-100">
            <HeaderDashboard toggleSidebar={()=>{toggleSidebar()}}/>
            <div className="d-flex flex-grow-1">
                <SideNav isOpen={isOpen}/>

                {/* Main Content */}
                <main className={`p-4 w-100 main`}>
                    {/*<Form8/>*/}
                    <Form8AddInformation/>
                </main>
            </div>
        </div>

    )

}

function Form8AddInformation() {
    const childRef = useRef();
    const navigate = useNavigate();
    const [isSubmit,setIsSubmit]=useState(false);
    function onSubmitOld() {
        const value = childRef.current.getValue();

        let form=new FormData();

        // ==== SECTION 1 ====
        form.append('Panchayat_No', value.panchayatAndDistrictNumber);

        // ==== SECTION 2 ====
        form.append('GramPanchayat_Name1', value.grampanchayat1);
        form.append('PanchayatSamiti_Name', value.panS);

        // ==== SECTION 3 ====
        form.append('year1', value.year1);
        form.append('year2', value.year2);

        // ==== SECTION 4 ====
        form.append('GramPanchayat_Name2', value.gramPanchayat2);

        // ==== SECTION 5 ====
        form.append('GramPanchayat_Name3', value.gramPanchayat3);
        form.append('Old_Property_No', value.oldPropertyNo);
        form.append('Taluka_Name', value.taluka);
        form.append('Zilla_Name', value.district);
        form.append('Sr_No', value.serialNo);
        form.append('Property_No', value.propertyNo);
        form.append('Owner_Name', value.ownerName);
        form.append('Wife_Name', value.wifeName);
        form.append('Occupant_Name', value.occupantName);

        // ==== ROW 1 ====
        form.append('Col6', JSON.stringify(value.Row1.sites));
        form.append('Col7', value.Row1.col7);
        form.append('Col8', JSON.stringify(value.Row1.col8));
        // form.append('Col9', value.Row1.total_area_east_west1);
        form.append('Col11', JSON.stringify(value.Row1.col11));
        form.append('ExtendData', JSON.stringify(value.extendRow)); // if array or object

        // ==== OTHER ====
        form.append('Box', JSON.stringify(value.box));
        form.append('Bhomikar', value.bhumikar);
        form.append('Total_groung', value.grandTotal);
        form.append('Tip', value.tip);
        form.append('Adhar', value.adharcard);
        form.append('Mobile', value.mobile);
        form.append('Col20', value.col20);
        form.append('Col21', value.col21);

        fetch(BaseURL+'GM.php/InsertForm8', {
            method: 'POST',
            body: form
        }).then(res =>back())
            .then(data => console.log(data));

    }

    async function onSubmit() {
        try {
            setIsSubmit(true);
            const value = childRef.current.getValue();

            let form = new FormData();

            // ==== SECTION 1 ====
            form.append('Panchayat_No', value.panchayatAndDistrictNumber);

            // ==== SECTION 2 ====
            form.append('GramPanchayat_Name1', value.grampanchayat1);
            form.append('PanchayatSamiti_Name', value.panS);

            // ==== SECTION 3 ====
            form.append('year1', value.year1);
            form.append('year2', value.year2);

            // ==== SECTION 4 ====
            form.append('GramPanchayat_Name2', value.gramPanchayat2);

            // ==== SECTION 5 ====
            form.append('GramPanchayat_Name3', value.gramPanchayat3);
            form.append('Old_Property_No', value.oldPropertyNo);
            form.append('Taluka_Name', value.taluka);
            form.append('Zilla_Name', value.district);
            form.append('Sr_No', value.serialNo);
            form.append('Property_No', value.propertyNo);
            form.append('Owner_Name', value.ownerName);
            form.append('Wife_Name', value.wifeName);
            form.append('Occupant_Name', value.occupantName);

            // ==== ROW 1 ====
            form.append('Col6', JSON.stringify(value.Row1.sites));
            form.append('Col7', value.Row1.col7);
            form.append('Col8', JSON.stringify(value.Row1.col8));
            form.append('Col11', JSON.stringify(value.Row1.col11));
            form.append('ExtendData', JSON.stringify(value.extendRow));

            // ==== OTHER ====
            form.append('Box', JSON.stringify(value.box));
            form.append('Bhomikar', value.bhumikar);
            form.append('Total_groung', value.grandTotal);
            form.append('Tip', value.tip);
            form.append('Adhar', value.adharcard);
            form.append('Mobile', value.mobile);
            form.append('Col20', value.col20);
            form.append('Col21', value.col21);

            // ==== API CALL ====
            const res = await fetch(BaseURL + 'GM.php/InsertForm8', {
                method: 'POST',
                body: form
            });

            // HTTP 200 nahi mila
            if (!res.ok) {
                let errorMessage = `Server Error (${res.status})`;

                try {
                    const errorData = await res.text();

                    if (errorData) {
                        errorMessage = errorData;
                    }
                } catch (e) {
                    // ignore parsing error
                }
                setIsSubmit(false);
                alert(errorMessage);
                return;
            }

            // Response 200 hone ke baad hi response read hoga
            const data = await res.text();

            console.log(data);

            // ==== SUCCESS ====
            back();

        } catch (error) {
            console.error(error);

            alert(
                error?.message ||
                'Something went wrong. Please try again.'
            );
            setIsSubmit(false);
        }
    }

    function back() {
        navigate("/admin/form8Page");
    }

    return (
        <div className="p-1">
            <FormHeader />
            <div className="card w-100 p-2 mb-3">
                <div className="parent">
                    <div className="child">
                        <FormTable ref={childRef} />
                    </div>
                </div>
                <div className="mt-4 mb-3 d-flex justify-content-center">

                    <button disabled={isSubmit} className="btn btn-primary m-2" onClick={onSubmit}>
                        Save
                    </button>
                    {/*<button onClick={back} className="btn btn-danger m-2">Cancel</button>*/}
                </div>
            </div>
        </div>
    );
}



function FormHeader() {
    return (
        <div className={"card w-100 p-2 mb-3"}>
            <span className={"text-secondary"}>Add Form 8 (नमुना ८)</span>
            <span className={"text-success"}>
                  To print this page set "Legal size" page and printing scale is (90%). in print setup Dialogbox.
              </span>
        </div>
    );
}

const FormTable=React.memo(forwardRef((props, ref)=>{

    const [count,setCount]=useState(0);
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let year = 1950; year <= currentYear; year++) {
        years.push(year);
    }
    // ====================section 1===============
    const [panchayatAndDistrictNumber,setPanchayatAndDistrictNumber]=useState("");
    // ====================section 2===============
    const [grampanchayat, setGrampanchayat] = useState(JSON.parse(sessionStorage.getItem('data'))[0].VilageName);
    const [panS, setPanS] = useState("");
    // ====================section 3===============
    const [year1, setYear1] = useState("");
    const [year2, setYear2] = useState("");
    // ====================section 4===============
    const [gramPanchayat, setGramPanchayat] = useState("");
    //=====================section 5==============
    const [gramPanchayat1, setGramPanchayat1] = useState("");
    const [oldPropertyNo, setOldPropertyNo] = useState("");
    const [taluka, setTaluka] = useState("");
    const [district, setDistrict] = useState("");
    const [serialNo, setSerialNo] = useState("");
    const [propertyNo, setPropertyNo] = useState("");
    const [ownerName, setOwnerName] = useState("");
    const [wifeName, setWifeName] = useState("");
    const [occupantName, setOccupantName] = useState("");
    //======================Row1========
    const [extendRow,setExtendRow]=useState([
        {
            Col9:"झोपडी किंवा मातीचे घर",
            Col10:{East_West:0,North_South:0},
            Col13_Col14:{Building:0,Land:0},
            Col15:0,
            Col16:{Building:0,Land:0},
            Col17:"निवासी",
            Col18:{Building:0,Land:0},
            Year:"",
            Sq_Ft:0,
            Sq_Mt:0,
            Col19_Gruhakar:0
        }
    ]);
    const [bhumikar,setBhumikar]=useState(0);
    const [box,setBox]=useState({
        box3:0,
        box4:0,
        box5:0,
        box6:0,
    });
    //=========col-6====
    const [sites, setSites] = useState({
        East: "",
        West: "",
        North: "",
        South: ""
    });

    const [total_area_east_west1, setTotal_area_east_west1] = useState("0");
    const [total_area_north_south1, setTotal_area_north_south1] = useState("0");
    const [total_area_east_west2, setTotal_area_east_west2] = useState("0");
    const [total_area_north_south2, setTotal_area_north_south2] = useState("0");
    const [remain_area, setRemain_area] = useState("0");
    const [remain_area1, setRemain_area1] = useState("0");

    //=============Open Space===
    const [openSpaceSq_Ft,setOpenSpaceSq_Ft]=useState(0);
    const [openSpaceSq_Mt,setOpenSpaceSq_Mt]=useState(0);
    //=========col-7====
    const [citySurveyNo,setCitySurveyNo]=useState('');

    //==========col-20========
    const [col20,setCol20]=useState(0);
    //==========col-21========
    const [col21,setCol21]=useState(0);
    //==========Row2=====
    const [total_sq_ft, setTotal_sq_ft] = useState("");
    const [grandTotal,setGrandTotal]=useState(0);
    //=========Row3=====
    const [total_sq_mt, setTotal_sq_mt] = useState("");

    //=========Tip======
    const [tip,setTip]=useState("");
    const [adharcard,setAdharcard]=useState("");
    const [mobile,setMobile]=useState("");

    useImperativeHandle(ref, () => ({
        getValue: () =>(
            {
                //=====Section1=======
                panchayatAndDistrictNumber:panchayatAndDistrictNumber,
                //=====Section2=======
                grampanchayat1:grampanchayat.trim(),
                panS:panS,
                //=====Section3=======
                year1:year1,
                year2:year2,
                //=====Section4=======
                gramPanchayat2:gramPanchayat.trim(),
                //=====Section5=======
                gramPanchayat3: gramPanchayat1.trim(),
                oldPropertyNo: oldPropertyNo,
                taluka: taluka,
                district: district.trim(),
                serialNo: serialNo,
                propertyNo: propertyNo,
                ownerName: ownerName,
                wifeName: wifeName,
                occupantName: occupantName,
                Row1:{
                    sites:sites,
                    col7:citySurveyNo,
                    col8:{
                        total_area_east_west1: total_area_east_west1,
                        total_area_north_south1: total_area_north_south1,
                        total_area_east_west2: total_area_east_west2,
                        total_area_north_south2: total_area_north_south2,
                        total_sq_ft:total_sq_ft,
                        total_sq_mt:total_sq_mt
                    },
                    col11:{
                        remain_area: remain_area,
                        remain_area1: remain_area1,
                        openSpaceSq_Ft:openSpaceSq_Ft,
                        openSpaceSq_Mt:openSpaceSq_Mt
                    },
                },
                bhumikar:bhumikar,
                box:box,
                col20:col20,
                col21:col21,
                grandTotal:grandTotal,
                tip:tip,
                adharcard:adharcard,
                mobile:mobile,
                extendRow:extendRow
            }
        )
    }));
    //============Lable==+and-==
    function Add() {
        const newRow = {
            Col9: "झोपडी किंवा मातीचे घर",
            Col10: { East_West: 0, North_South: 0 },
            Col13_Col14:{Building:0,Land:0},
            Col15: 0,
            Col16: { Building: 0, Land: 0 },
            Col17: "निवासी",
            Col18: { Building: 0, Land: 0 },
            Year: "",
            Sq_Ft: "",
            Sq_Mt: "",
            Col19_Gruhakar: 0
        };
        setExtendRow(prev => [...prev, newRow]);
        setCount(prev => prev + 1);
    }

    function Remove() {
        if(count!=0){
            setExtendRow(prev => prev.slice(0, -1));
            setCount(prev => prev - 1);
        }
    }

    //===========Row1 Function=====
    const handleSiteChange = (key,value) => {
        updateSite(key,value);
    };
    const updateSite = (key, value) => {
        setSites(prev => ({
            ...prev,
            [key]: value
        }));
    };
    //calcuate Fit and mitter
    const handleAreaChange = (key, e) => {
        const val = e;
        if (key === 'ew1') setTotal_area_east_west1(val);
        else if (key === 'ns1') setTotal_area_north_south1(val);
        else if (key === 'ew2') setTotal_area_east_west2(val);
        else if (key === 'ns2') setTotal_area_north_south2(val);
    };
    useEffect(()=>{
        const res = (total_area_east_west1 * total_area_north_south1)+(total_area_east_west2 * total_area_north_south2);
        setTotal_sq_ft(res);//total_sq_ft
        setTotal_sq_mt(parseFloat(res*0.093));
        setRemain_area(parseFloat(res*0.093));
    },[total_area_east_west1,total_area_north_south1,total_area_east_west2,total_area_north_south2])

    const handleRemainChange = (key, e) => {
        const val = e;
        if (key === 'remain1') setRemain_area(val);
        else if (key === 'remain2') setRemain_area1(val);
    };

    //==============Add Extra====
    const onChangeAddExtra=(data,index)=>{
        updateExtendRowValue(index,data.key,data.data);
        if(data.key==="Col10"){
            //calBuildArea
            let  _build_area_east_west=data.data.East_West;
            let  _build_area_north_south=data.data.North_South;
            let res = _build_area_east_west*_build_area_north_south;
            updateExtendRowValue(index,"Sq_Ft",res);
            updateExtendRowValue(index,"Sq_Mt",(res*0.093).toFixed(3));
        }else
            if(data.key==="Col13Col14"||data.key==="Col15"||data.key==="Col18"||data.key=="box3"||data.key=="box4"||data.key=="box5"||data.key=="box6")
            {
                //calHomeTax
                let resTotal=0;
                let total_build_area_sq_mt=extendRow[index].Sq_Mt;
                let redireknar_build=extendRow[index].Col13_Col14.Building;
                let ghasara=extendRow[index].Col15;
                let ghasara1=ghasara/100;
                //Col16.Building never use as input
                let tax_price_build=extendRow[index].Col18.Building;
                //=======set value===========
                let res = total_build_area_sq_mt*redireknar_build*ghasara1;
                let rest1 = res*tax_price_build;
                updateNestedExtendRowValue(index, "Col16", "Building", rest1);
                //========================
                let thausand = 1000;
                let res2 = rest1/thausand;
                resTotal= resTotal+res2;
                updateExtendRowValue(index,"Col19_Gruhakar",res2);
                setGrandTotal(resTotal.toFixed(3));
                //========calLandTax=======
                {
                    let total_remain_sq_mt=  openSpaceSq_Mt; //#780000  col=11 Row=3 khali jaga
                    let redireknar_land =  extendRow[0].Col13_Col14.Land; //col=14 Row=1 Jamin

                    let tax_price_land=extendRow[0].Col18.Land;
                    let res = total_remain_sq_mt*redireknar_land*tax_price_land;
                    updateNestedExtendRowValue(index, "Col16", "Land", res);
                    let res1 = res/1000;
                    setBhumikar(res1);
                }

            }
    }
    const updateExtendRowValue = (index, key, value) => {
        setExtendRow(prev => {
            const updated = [...prev];
            updated[index] = {
                ...updated[index],
                [key]: value
            };
            return updated;
        });
    }
    const updateNestedExtendRowValue = (index, parentKey, childKey, value) => {
        setExtendRow(prev => {
            const updated = [...prev];
            updated[index] = {
                ...updated[index],
                [parentKey]: {
                    ...updated[index][parentKey],
                    [childKey]: value
                }
            };
            return updated;
        });
    };
    useEffect(()=>{
        setOpenSpaceSq_Ft(total_sq_ft-extendRow[0].Sq_Ft);
        setOpenSpaceSq_Mt(total_sq_mt-extendRow[0].Sq_Mt);
    },[extendRow]);
    //============onChange Box=========
    const onChangeBox=(key,value,index)=> {
        onChangeAddExtra({key:"box3"},index);
        updateBoxValue(key,value);
    }
    const updateBoxValue = (key, value) => {
        setBox(prev => ({
            ...prev,
            [key]: value
        }));
    };
    useEffect(()=>{
        let _home_tax_grand_total=parseFloat(grandTotal);
        let _bhumikar=parseFloat(bhumikar);
        let _vijkar=parseFloat(box.box3);
        let _arogyakar=parseFloat(box.box4);

        let _sa_panikar=parseFloat(box.box5);
        let _vi_panikar=parseFloat(box.box6);

        let _ress = _home_tax_grand_total+_bhumikar+_vijkar+_arogyakar+_sa_panikar+_vi_panikar;
        setCol20(_ress);
    },[box]);

    return (
        <div className={"overflow-size "}>

            <Section1
                value={panchayatAndDistrictNumber}
                onChange={(e) => setPanchayatAndDistrictNumber(e.target.value)}/>

            <Section2
                grampanchayat={grampanchayat}
                setGrampanchayat={setGrampanchayat}
                panS={panS}
                setPanS={setPanS}
            />
            <Section3
                year1={year1}
                setYear1={setYear1}
                year2={year2}
                setYear2={setYear2}
            />
            <Section4
                gramPanchayat={gramPanchayat}
                setGramPanchayat={setGramPanchayat}
            />

            <Section5
                gramPanchayat={gramPanchayat1} setGramPanchayat={setGramPanchayat1}
                oldPropertyNo={oldPropertyNo} setOldPropertyNo={setOldPropertyNo}
                taluka={taluka} setTaluka={setTaluka}
                district={district} setDistrict={setDistrict}
                serialNo={serialNo} setSerialNo={setSerialNo}
                propertyNo={propertyNo} setPropertyNo={setPropertyNo}
                ownerName={ownerName} setOwnerName={setOwnerName}
                wifeName={wifeName} setWifeName={setWifeName}
                occupantName={occupantName} setOccupantName={setOccupantName}
            />

            {/*==============5=Big==========*/}
            <div className={"mt-3 bigTable"}>
                <table className="custom-table">
                    <Thead/>
                    <tbody>
                    {/*---------------Number------------*/}
                    <ColumnNumber/>
                    {/*-------------------Label---------*/}
                    <LableColumn Add={Add} Remove={Remove}  count={count} setCount={setCount} />
                    {/*----------------Row1---------------*/}
                    <Row1
                        sites={sites}
                        handleSiteChange={handleSiteChange}
                        handleAreaChange={handleAreaChange}
                        handleRemainChange={handleRemainChange}
                        total_area_east_west1={total_area_east_west1}
                        total_area_north_south1={total_area_north_south1}
                        total_area_east_west2={total_area_east_west2}
                        total_area_north_south2={total_area_north_south2}
                        remain_area={remain_area}
                        remain_area1={remain_area1}
                        valueCol7={citySurveyNo}
                        onChangeCol7={(value)=>setCitySurveyNo(value)}
                        years={years}
                        onChangeAddExtra={onChangeAddExtra}
                        extendRow={extendRow[0]}
                        bhumikar={bhumikar}
                        onChangeBox={onChangeBox}
                        index={0}
                        box={box}
                        col20={col20}
                        col21={col21}
                        setCol21={setCol21}
                    />
                    {/*----------------Row2---------------*/}
                    <Row2 total_sq_ft={total_sq_ft}
                          openSpaceSq_Ft={openSpaceSq_Ft}
                          grandTotal={grandTotal}
                          extendRow={extendRow[0]}
                    />
                    {/*----------------Row3---------------*/}
                    <Row3 total_sq_mt={total_sq_mt}
                          openSpaceSq_Mt={openSpaceSq_Mt}
                          extendRow={extendRow[0]}
                    />
                    {/*----------------Row4---------------*/}
                    <Row4/>
                    {/*=========================Extra Data==========================================================================================================================================================*/}
                    {Array.from({ length: count }, (_, index) => (
                        // <AddExtra key={`item${index}`}/>
                        <AddExtraField key={`item${index}`} index={index+1}
                                       extendRow={extendRow[index+1]}
                                       onChangeAddExtra={onChangeAddExtra}  />
                                       ))}

                    {/*=========================Extra Data================================*/}
                    {/*----------------Tip---------------*/}
                    <Tip tip={tip} setTip={setTip} adharcard={adharcard} setAdharcard={setAdharcard} mobile={mobile} setMobile={setMobile}/>
                    </tbody>
                </table>
            </div>


            {/*==============6===========*/}
            <Form8LastInfo/>

        </div>
    )

}));



function AddExtra() {
    const currentYear = new Date().getFullYear();
    const years = [];

    for (let year = 1950; year <= currentYear; year++) {
        years.push(year);
    }

    return (
        <>
            {/*----------------Row1---------------*/}
            <tr className="custom-row td">
                {/*------6----------*/}
                <td colSpan={4} rowSpan={3}></td>
                {/*------7----------*/}
                {/*------8----------*/}
                {/*------11----------*/}
                {/*------9----------*/}
                <td>
                    <select name="property_details[0]">
                        <option value="झोपडी किंवा मातीचे घर">झोपडी किंवा मातीचे घर</option>
                        <option value="दगडी विटा मातीचे घर">दगडी विटा मातीचे घर</option>
                        <option value="दगडीविटा चुना/सिमेंटचे घर">दगडीविटा चुना/सिमेंटचे घर</option>
                        <option value="आर.सी.सी स्लबचे घर">आर.सी.सी स्लबचे घर</option>
                        <option value="खाली जागा">खाली जागा</option>
                        <option value="पहिला मजला">पहिला मजला</option>
                        <option value="दुसरा मजला ">दुसरा मजला </option>
                        <option value="तिसरा  मजला ">तिसरा  मजला </option>
                    </select>
                </td>
                {/*------10----------*/}
                <td>
                    <table className="w-100">
                        <tbody>
                        <tr className="td-size">
                            <td className="size-2"><input value={0} /></td>
                            <td className="size-2"><input value={0} /></td>
                        </tr>
                        </tbody>
                    </table>
                </td>
                {/*------12----------*/}
                <td>
                    <select>
                        <option value="">Select Year</option>
                        {years.map((year) => (
                            <option key={year} value={year}>
                                {year}
                            </option>
                        ))}
                    </select>
                </td>
                {/*------13 & 14----------*/}
                <td>
                    <table className="w-100">
                        <tbody>
                        <tr className="td-size">
                            <td className="size-2"><input value="0" /></td>
                            <td className="size-2"><input value="0" /></td>
                        </tr>
                        </tbody>
                    </table>
                </td>
                {/*------15----------*/}
                <td><input value="0" /></td>
                {/*------16----------*/}
                <td>
                    <table className="w-100">
                        <tbody>
                        <tr className="td-size">
                            <td className="size-2"><input value="0" /></td>
                            <td className="size-2"><input value="0" /></td>
                        </tr>
                        </tbody>
                    </table>
                </td>
                {/*------17----------*/}
                <td>
                    <select>
                        <option value="निवासी">निवासी</option>
                        <option value="व्यावसायिक">व्यावसायिक</option>
                        <option value="औधोगीक">औधोगीक</option>
                    </select>
                </td>
                {/*------18----------*/}
                <td>
                    <table className="w-100">
                        <tbody>
                        <tr className="td-size">
                            <td className="size-2"><input value="0" /></td>
                            <td className="size-2"><input value="0" /></td>
                        </tr>
                        </tbody>
                    </table>
                </td>
                {/*------19, 20, 21----------*/}
                <td colSpan={3} className="text-start">
                    <input value={0} />
                </td>
            </tr>

            {/*----------------Row2---------------*/}
            <tr className="custom-row td">
                {/*------6----------*/}
                {/*<td></td>*/}
                {/*------7----------*/}
                {/*<td></td>*/}
                {/*------8----------*/}
                {/*<td></td>*/}
                {/*------11----------*/}
                {/*<td className="size-2"></td>*/}
                {/*------9----------*/}
                <td rowSpan={2}></td>
                {/*------10----------*/}
                <td>
                    <table className="w-100">
                        <tbody>
                        <tr><td>Sq.Ft.</td></tr>
                        <tr className="td-size">
                            <td className="size-2"><input value={0} /></td>
                        </tr>
                        </tbody>
                    </table>
                </td>
                {/*------12----------*/}
                <td colSpan={9} rowSpan={2}></td>
                {/*------13 & 14----------*/}
                {/*<td></td>*/}
                {/*------15----------*/}
                {/*<td></td>*/}
                {/*------16----------*/}
                {/*<td></td>*/}
                {/*------17----------*/}
                {/*<td></td>*/}
                {/*------18----------*/}
                {/*<td></td>*/}
                {/*------19, 20, 21----------*/}
                {/*<td colSpan={3}></td>*/}
            </tr>

            {/*----------------Row3---------------*/}
            <tr className="custom-row td">
                {/*------6----------*/}
                {/*<td></td>*/}
                {/*------7----------*/}
                {/*<td></td>*/}
                {/*------8----------*/}
                {/*<td></td>*/}
                {/*------11----------*/}
                {/*<td className="size-2"></td>*/}
                {/*------9----------*/}
                {/*<td></td>*/}
                {/*------10----------*/}
                <td>
                    <table className="w-100">
                        <tbody>
                        <tr><td>Sq.Mt.</td></tr>
                        <tr className="td-size">
                            <td className="size-2"><input value={0} /></td>
                        </tr>
                        </tbody>
                    </table>
                </td>
                {/*------12----------*/}
                {/*<td></td>*/}
                {/*------13 & 14----------*/}
                {/*<td></td>*/}
                {/*------15----------*/}
                {/*<td></td>*/}
                {/*------16----------*/}
                {/*<td></td>*/}
                {/*------17----------*/}
                {/*<td></td>*/}
                {/*------18----------*/}
                {/*<td></td>*/}
                {/*------19, 20, 21----------*/}
                {/*<td colSpan={3}></td>*/}
            </tr>
        </>
    );
}



//==============New====================




const Form8Header = () => {
    return (
        <div className="panel box-shadow-none content-header">
            <div className="panel-body">
                <div className="col-md-12">
                    Add Form 8 (नमुना ८)
                    <br />
                    <span style={{ color: '#CC0523' }}> </span>
                </div>
                <div className="col-md-10" style={{ color: '#3CAF12' }}>
                    To print this page set "Legal size" page and printing scale is (90%). in print setup Dialogbox.
                </div>
                <div className="col-md-2"></div>
            </div>
        </div>
    );
};




